import { SvgIcon } from '@mui/material';

const LogoIcon = () => (
    <SvgIcon viewBox='0 0 512 512' >
        <rect width='390' height='492' x='10' y='10' fill='#2aa2da' fillOpacity='0.4' stroke='#2aa2da' strokeWidth='20'/>
        <rect width='492' height='288' x='10' y='214' fill='#5fc869' fillOpacity='0.4' stroke='#5fc869' strokeWidth='20'/>
    </SvgIcon>
);

export default LogoIcon;